import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import { getAddOns } from "../store/actions/cartAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ProductDetailModal = ({
  isOpen,
  toggle,
  data,
  darkMode,
  color,
  currency,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { addOnsDetail } = useSelector((state) => state.cart);
  const name = data?.name || data?.menuDetail?.name || "Item Detail";
  const images = data?.images || data?.menuDetail?.images || [];
  const time = data?.estimatedTime || data?.menuDetail?.estimatedTime || "-";
  const variants = data?.variants || data?.menuDetail?.variants || [];
  const labels = data?.labels || [];
  const [selectedImage, setSelectedImage] = useState(images[0]);

  useEffect(() => {
    setSelectedImage(images[0]);
  }, [data, images]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedImage(images[0]);
    }
  }, [isOpen, images]);

  useEffect(() => {
    if (isOpen && data?.menuDetail?.addOns) {
      dispatch(getAddOns(data.menuDetail.addOns));
    }
  }, [data?.menuDetail?.addOns, dispatch, isOpen]);

  const headerColor = color || (darkMode ? "#b71c1c" : "#d32f2f");
  const bgColor = darkMode ? "#1e1e1e" : "#f9f9f9";
  const cardBg = darkMode ? "#2c2c2c" : "#f0f0f0";
  const textColor = darkMode ? "#e0e0e0" : "#000";
  const cardStyle = {
    backgroundColor: cardBg,
    padding: "14px 18px",
    borderRadius: "10px",
    border: darkMode ? "1px solid #444" : "1px solid #ddd",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease-in-out",
  };

  const handleAddToCart = () => {
    history.push(`/productDetails/${data?.itemId}`);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      fade={false}
      style={{ maxWidth: "850px", width: "95%" }}
      contentClassName="border-0"
    >
      <div
        style={{
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: "5px",
          overflow: "hidden",
          maxHeight: "75vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ModalHeader
          toggle={toggle}
          style={{
            backgroundColor: headerColor,
            color: "#fff",
            borderBottom: "none",
            fontWeight: "600",
            fontSize: "1.25rem",
            padding: "1.25rem 1.5rem",
            position: "sticky",
            top: 0,
            zIndex: 1,
            flexShrink: 0,
          }}
          close={
            <button
              className="close"
              onClick={toggle}
              style={{
                color: "#fff",
                fontSize: "1.75rem",
                fontWeight: "400",
                lineHeight: "1",
                opacity: 1,
                position: "absolute",
                top: "12px",
                right: "20px",
                background: "transparent",
                border: "none",
                outline: "none",
              }}
            >
              &times;
            </button>
          }
        >
          {name}
        </ModalHeader>

        <ModalBody
          style={{
            padding: "1.75rem",
            backgroundColor: darkMode ? "#2a2a2a" : "#fff",
            color: textColor,
            overflowY: "auto",
            flex: 1,
          }}
        >
          <Row>
            <Col md={5}>
              <div
                className="rounded-lg overflow-hidden"
                style={{ height: "250px" }}
              >
                <img
                  src={selectedImage || images[0]}
                  alt={name}
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>

              {images?.length > 1 && (
                <div className="d-flex flex-wrap mt-2" style={{ gap: "8px" }}>
                  {images
                    .filter((img) => img !== selectedImage)
                    .map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        onClick={() => setSelectedImage(img)}
                        alt={`thumb-${idx}`}
                        style={{
                          width: "70px",
                          height: "70px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          cursor: "pointer",
                          transition: "0.2s ease-in-out",
                        }}
                      />
                    ))}
                </div>
              )}
              {/* <Button
                color="primary"
                block
                className="mt-3 fw-bold text-white"
                onClick={handleAddToCart}
                style={{
                  backgroundColor: headerColor,
                  borderColor: headerColor,
                }}
              >
                Add to Cart
              </Button> */}
            </Col>
            <Col md={7}>
              <div
                style={{
                  paddingLeft: "1rem",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ flex: 1 }}>
                  {time && (
                    <h6 className="py-3 py-md-0 mb-0 mb-md-3 fw-bold d-flex align-items-center">
                      Estimated Time:
                      <span className="fw-normal text-muted ml-2">
                        {time} mins
                      </span>
                    </h6>
                  )}

                  {variants?.length > 0 && (
                    <div className="mb-4">
                      <h6 className="fw-bold mb-2">Variants:</h6>
                      {variants?.map((v, idx) => (
                        <div
                          key={idx}
                          className="hover-effect-box"
                          style={{
                            ...cardStyle,
                            marginBottom: "10px",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <span>
                              <strong>Size:</strong> {v.size}
                            </span>
                            <span>
                              <strong>Price:</strong> {currency || "$"}{" "}
                              {v.price}
                            </span>
                          </div>
                          {v.calories && (
                            <div className="mt-1">
                              <strong>Calories:</strong> {v.calories}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {labels?.length > 0 && (
                    <>
                      <h6 className="mb-3 fw-bold">Labels: </h6>
                      <div
                        className="d-flex flex-wrap"
                        style={{ gap: "10px", marginBottom: "1.5rem" }}
                      >
                        {labels?.map((label, idx) => {
                          const labelId = `label_${idx}_${label.id}`;
                          return (
                            <div
                              key={label.id}
                              id={labelId}
                              className="hover-effect-box d-flex flex-column align-items-center"
                              style={{
                                ...cardStyle,
                                padding: "10px 12px",
                                width: "100px",
                                textAlign: "center",
                                position: "relative",
                              }}
                            >
                              <img
                                src={label.labelURL}
                                alt={label.label}
                                width={32}
                                height={32}
                                style={{ objectFit: "contain" }}
                              />
                              <span
                                className="mt-2"
                                style={{
                                  fontSize: "0.85rem",
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {label.label}
                              </span>
                              <UncontrolledTooltip
                                placement="bottom"
                                target={labelId}
                              >
                                {label.label}
                              </UncontrolledTooltip>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}

                  {addOnsDetail?.length > 0 && (
                    <>
                      <h6 className="py-3 fw-bold">AddOns</h6>
                      <div
                        className="d-flex flex-column"
                        style={{ gap: "12px", marginBottom: "1rem" }}
                      >
                        {addOnsDetail?.map((addOn, idx) => {
                          const hasDescription = Boolean(
                            addOn?.description?.trim()
                          );

                          return (
                            <div
                              key={idx}
                              className="hover-effect-box d-flex"
                              style={{
                                ...cardStyle,
                                alignItems: hasDescription
                                  ? "flex-start"
                                  : "center",
                                gap: "14px",
                              }}
                            >
                              <img
                                src={addOn?.image}
                                alt={addOn?.name}
                                width={50}
                                height={50}
                                style={{
                                  objectFit: "contain",
                                  borderRadius: "6px",
                                  flexShrink: 0,
                                }}
                              />

                              <div style={{ flex: 1 }}>
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <strong
                                    style={{
                                      fontSize: "1rem",
                                      color: darkMode ? "#eee" : "#222",
                                    }}
                                  >
                                    {addOn?.name}
                                  </strong>
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "0.95rem",
                                      color: darkMode ? "#ccc" : "#444",
                                    }}
                                  >
                                    {currency || "$"}
                                    {addOn?.price === 0 ? "Free" : addOn?.price}
                                  </span>
                                </div>

                                {hasDescription && (
                                  <div
                                    style={{
                                      fontSize: "0.87rem",
                                      color: darkMode ? "#aaa" : "#666",
                                      overflow: "hidden",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      lineHeight: "1.3rem",
                                      maxHeight: "2.6rem",
                                      textOverflow: "ellipsis",
                                    }}
                                    title={addOn.description}
                                  >
                                    {addOn.description}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default ProductDetailModal;
